import React, { useRef } from 'react';
import {
  View,
  StyleSheet,
  TextInput as BaseTextInput,
  StyleProp,
  TextInputProps,
  ViewStyle,
} from 'react-native';
import { Text } from 'exoflex';
import { TEXT, TEXT_INPUT } from '../constants/colors';

type Props = TextInputProps & {
  value: string;
  errorMessage?: string | null;
  disabled?: boolean;
  label: string;
  placeholder?: string;
  containerStyle?: StyleProp<ViewStyle>;
  textInputStyle?: StyleProp<ViewStyle>;
};

export default function TextInput(props: Props) {
  let ref = useRef<BaseTextInput>(null);
  let {
    value,
    errorMessage,
    disabled = false,
    label,
    placeholder,
    containerStyle,
    textInputStyle,
    ...otherProps
  } = props;

  return (
    <View
      style={[
        styles.container,
        disabled ? styles.disableTextInput : null,
        containerStyle,
      ]}
    >
      <View style={[styles.textContainer]}>
        <Text style={[styles.labelText]}>{label}</Text>
      </View>
      <BaseTextInput
        ref={ref}
        editable={!disabled}
        value={value}
        style={[
          styles.textInput,
          errorMessage ? styles.errorTextInput : null,
          textInputStyle,
        ]}
        placeholder={placeholder}
        {...otherProps}
      />
      <View style={styles.bottomTextInput}>
        {errorMessage && <Text style={styles.errorText}>{errorMessage}</Text>}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    marginBottom: 10,
  },
  labelText: {
    fontSize: 14,
    color: TEXT.blackOpacity,
  },
  textContainer: {
    marginBottom: 8,
  },
  textInput: {
    flex: 1,
    borderColor: TEXT_INPUT.borderDefault,
    borderWidth: 1,
    borderRadius: 4,
    alignContent: 'stretch',
    paddingVertical: 14,
    paddingHorizontal: 16,
    fontFamily: 'SourceSansPro-Regular',
    fontSize: 16,
    minHeight: 48,
  },
  disableTextInput: {
    opacity: 0.5,
  },
  errorTextInput: {
    borderColor: TEXT_INPUT.borderError,
  },
  bottomTextInput: {
    marginTop: 4,
    flexDirection: 'row',
    justifyContent: 'space-between',
    height: 17,
  },
  errorText: {
    color: TEXT.red,
  },
});
